import { useSyncExternalStore } from "react";
import { getHeldConfirmToken, isConfirmHash, subscribeConfirmToken } from "@/lib/signup-route";

function subscribeHash(callback: () => void): () => void {
  // Токен из адреса забирает перехватчик `watchSignupHash` из `main.tsx`.
  window.addEventListener("hashchange", callback);
  return () => window.removeEventListener("hashchange", callback);
}

function getActive(): boolean {
  return isConfirmHash(window.location.hash);
}

/**
 * Маршрут подтверждения почты (`#/confirm`, `#/confirm/{token}`): открыта ли
 * страница и какой токен принесён. Сам токен лежит в памяти, из адреса убран
 * (`signup-route.ts`); `null` при открытой странице — токена нет (stage9-email-confirmation, Р11).
 */
export function useConfirmRoute(): { active: boolean; token: string | null } {
  const active = useSyncExternalStore(subscribeHash, getActive);
  const token = useSyncExternalStore(subscribeConfirmToken, getHeldConfirmToken);
  return { active, token };
}
